import React, { useState } from 'react';
import { Minus, Plus, ChevronDown } from 'lucide-react';

const ZoomControl = ({ zoomLevel, onZoomChange, onZoomIn, onZoomOut }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const zoomLevels = [25, 50, 75, 100, 125, 150, 200, 300, 400, 500];

  const handleZoomSelect = (level) => {
    onZoomChange(level);
    setShowDropdown(false);
  };

  return (
    <div className="flex items-center gap-1 bg-black rounded px-2 py-1 shadow-lg">
      {/* Zoom Out Button */}
      <button
        onClick={onZoomOut}
        disabled={zoomLevel <= zoomLevels[0]}
        className="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded disabled:opacity-50 disabled:cursor-not-allowed"
        title="Zoom Out"
      >
        <Minus size={12} />
      </button>

      {/* Zoom Level Display with Dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center gap-1 px-2 py-1 text-white text-sm hover:bg-gray-700 rounded min-w-[60px] justify-center"
          title="Zoom Level"
        >
          <span>{zoomLevel}%</span>
          <ChevronDown size={10} />
        </button>

        {/* Dropdown Menu */}
        {showDropdown && (
          <div className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 bg-black border border-gray-600 rounded shadow-lg py-1 z-50">
            {zoomLevels.map((level) => (
              <button
                key={level}
                onClick={() => handleZoomSelect(level)}
                className={`w-full px-3 py-1 text-left text-sm hover:bg-gray-700 ${
                  level === zoomLevel ? 'bg-gray-700 text-white' : 'text-gray-300'
                }`}
              >
                {level}%
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Zoom In Button */}
      <button
        onClick={onZoomIn}
        disabled={zoomLevel >= zoomLevels[zoomLevels.length - 1]}
        className="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded disabled:opacity-50 disabled:cursor-not-allowed"
        title="Zoom In"
      >
        <Plus size={12} />
      </button>
    </div>
  );
};

export default ZoomControl;